export default {
  'pages.applicationCenter.card.free': '免费',
  'pages.applicationCenter.card.paid': '付费',
  'pages.applicationCenter.card.perSeat': '按席位计费',
  'pages.applicationCenter.card.pricePending': '价格待确认',
  'pages.applicationCenter.card.developerUnknown': '开发者未提供',
  'pages.applicationCenter.card.noDescription':
    '暂无应用简介，进入详情了解更多。',
  'pages.applicationCenter.card.official': '官方认证',
  'pages.applicationCenter.card.installed': '已开通',
};
